import React from 'react';
import classNames from 'classnames';
import SideCart from './components/SideCart';
import SideVendor from './components/side-vendor';
import SideCategories from './components/side-categories';
import MinimumCheckoutAlert from '../components/MinimumCheckoutAlert';

import CartFloatingButton from '../components/CartFloatingButton';
import ScrollToTopFloatingButton from '../components/scroll-to-top-floating-button';
import BaseLayout from './BaseLayout';
import { useMenu2 } from '../hooks/useMenu2';
import { Link } from 'react-router-dom';
import { POLICY_REFUND_ROUTE } from '../router/constants';
import { useRestaurant } from '../contexts/restaurant.context';

const MenuLayout = ({ children }) => {
    const { isMenu2 } = useMenu2();
    const restaurant = useRestaurant();
    
    return (
        <BaseLayout>
            <div className={classNames('container-fluid px-3 with-sidebar restaurant', {
                'menu-2': isMenu2
            })}>
                <div className="row flex-xl-nowrap">
                    <MinimumCheckoutAlert />
                    
                    <CartFloatingButton />
                    <ScrollToTopFloatingButton />

                    <SideVendor/>

                    <div className="col content col-xl-9 pb-5">

                        {children}

                        
                        {restaurant?.is_show_cancellation_refund_policy && (
                            <div className="mt-4 text-center">
                                <Link className="" to={POLICY_REFUND_ROUTE}>
                                    Refund Policy
                                </Link>
                            </div>
                        )}
                    </div>

                    <SideCart />
                    <SideCategories />
                </div>
            </div>
        </BaseLayout>
    );
};

export default MenuLayout;
